"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplate = void 0;
var NotificationTemplateStore_1 = __importDefault(require("./Store/NotificationTemplateStore"));
var NotificationTemplate = /** @class */ (function () {
    function NotificationTemplate(session) {
        this.notificationTemplateStore = new NotificationTemplateStore_1.default(session);
    }
    NotificationTemplate.prototype.getAll = function () {
        return this.notificationTemplateStore.getAll();
    };
    NotificationTemplate.prototype.getByNames = function (names) {
        return this.notificationTemplateStore.notificationTemplateService.getByNames(names);
    };
    NotificationTemplate.prototype.create = function (request) {
        return this.notificationTemplateStore.create(request);
    };
    NotificationTemplate.prototype.update = function (id, request) {
        return this.notificationTemplateStore.update(id, request);
    };
    NotificationTemplate.prototype.delete = function (id) {
        return this.notificationTemplateStore.delete(id);
    };
    return NotificationTemplate;
}());
exports.NotificationTemplate = NotificationTemplate;
//# sourceMappingURL=NotificationTemplate.js.map